import { useFormContext, useWatch } from "react-hook-form";
import { useWatchDebounced } from "./useWatchDebounced";
import { useMemo } from "react";
const useFormWatch = <T extends string>(fields?: T[]) => {
  const { control } = useFormContext();
  const config = {
    control: control,
    name: fields || undefined,
    defaultValue: fields ? ({} as Record<T, any>) : undefined
  } as const;
  const values = useWatch(config);

  const debouncedValues = useWatchDebounced(values, 500);

  const watchedValues = useMemo(() => {
    const result: Record<string, any> = {};
    if (typeof fields === "undefined" || fields?.length === 0) {
      return debouncedValues;
    }
    // Si fields es un array, lo procesamos como tal
    if (Array.isArray(fields)) {
      fields.forEach((field, index) => {
        // Si values es un array, usamos el índice; de lo contrario accedemos por nombre
        result[field] = Array.isArray(values) ? values[index] : values[field];
      });
    }

    return result;
  }, [debouncedValues, fields]);

  return watchedValues as Record<T, any>;
};

export default useFormWatch;
